import React, { useState, useEffect } from "react";
import apiClient from '../utils/apiClient';
import Select from "react-select";
import Swal from 'sweetalert2';
import { SERVER_BASE } from '../config/server';
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle, faTrash, faEdit, faCopy, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { useTable, usePagination, useSortBy, useGlobalFilter } from "react-table";
import usePermissions from '../utils/usePermissions';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useLocation, useNavigate } from "react-router-dom";
// Global Search Filter Component
const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <input
      value={filter || ''}
      onChange={(e) => setFilter(e.target.value)}
      placeholder="Search items..."
      style={{
        marginBottom: '10px',
        padding: '8px',
        fontSize: '16px',
        width: '100%',
        boxSizing: 'border-box',
      }}
      className='form-control'
    />
  );
};

const ItemMaster = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [itemGroup, setItemGroup] = useState(null);
  const [type, setType] = useState(null);
  const [itemGroupCode, setItemGroupCode] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [printName, setPrintName] = useState("");
  const [itemDesc, setItemDesc] = useState("");
  const [size, setSize] = useState("");
  const [make, setMake] = useState("");
  const [color, setColor] = useState("");
  const [avgWeight, setAvgWeight] = useState("");
  const [uom, setUom] = useState(null);
  const [disableStructureFields, setDisableStructureFields] = useState(false);
  const [unit, setUnit] = useState("");
  const [concernedDepartments, setConcernedDepartments] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [additionalNames, setAdditionalNames] = useState([""]);
  const [grade, setGrade] = useState("");
  const [brandName, setBrandName] = useState("");
  const [mmsCode, setMmsCode] = useState("");
  const [mmsName, setMmsName] = useState("");
  const [mmsDesc, setMmsDesc] = useState("");
  const [hsn, setHsn] = useState("");
  const [groupItemName, setGroupItemName] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [items, setItems] = useState([]); // State for table data
  const code = localStorage.getItem("code");
  const email = localStorage.getItem("email");
  const token = localStorage.getItem("token");
  const role = localStorage.getItem('role');
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const [formVisible, setFormVisible] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [uoms, setUoms] = useState([]); // UOM data
  const [groupItems, setGroupItems] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const item = location?.state?.item;
  const cloneItem = location?.state?.cloneItem;
  const onlyDept = location?.state?.onlyDept;;
  useEffect(() => {
    if (item) {
      handleEdit(item);
    }
  }, [item]);
  useEffect(() => {
    if (cloneItem) {
      handleClone(cloneItem);
    }
  }, [cloneItem]);
  // Fetch Inventory Groups
  const fetchItemGroups = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/item-groups", {
        params: { code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setItemGroups(
        response.data.map((group) => ({
          value: group.groupName,
          label: `${group.groupCode} - ${group.groupName}`,
          type: group.type,
          itemGroupCode: group.groupCode,
        }))
      );
    } catch (error) {
      console.error("Error fetching item groups:", error);
    }
  };
  const fetchGroupItems = async () => {
    try {
      // Retrieve the token from localStorage
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('Unauthorized: No token found.');
        return;
      }
      // Make the request with the Authorization header
      const response = await apiClient.get(SERVER_BASE + '/getGroupItems', {
        headers: {
          Authorization: `Bearer ${token}`, // Include the JWT token in headers
        },
      });

      // Update the purposes state
      setGroupItems(response.data);
    } catch (error) {
      console.error('Error fetching groups:', error);
    }
  };
  const fetchUOMs = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/getUoms", {
        params: { code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setUoms(
        response.data.map((uom) => ({
          value: uom.abbreviation,
          label: `${uom.unit} - ${uom.abbreviation}`,
          unit: uom.unit
        }))
      );
    } catch (error) {
      console.error("Error fetching item groups:", error);
    }
  };

  // Fetch Departments
  const fetchDepartments = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/departments", {
        params: { code },

        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },

      });
      const departmentsData = response.data;
      setDepartments(
        departmentsData.map((dept) => ({
          value: dept.name,
          label: dept.name,
        }))
      );
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  // Fetch items for the table
  const fetchItems = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/get-items-all", {
        params: { centerCode: code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const toggleFormVisibility = () => {
    setFormVisible(!formVisible);
    navigate('../InventoryMasterListing')
  };

  const toggleGroupFormVisibility = () => {
    setFormVisible(false);
    setShowForm(!showForm)
    resetForm();
    resetGroupForm();
  };
  const resetGroupForm = () => {
    setGroupItemName('');
    setSelectedItems([]);
  };
  const resetForm = () => {
    setItemGroup(null);
    setType(null);
    setItemGroupCode("");
    setItemName("");
    setItemDesc("");
    setSize("");
    setMake("");
    setColor("");
    setAvgWeight("");
    setUom(null);
    setUnit("");
    setGrade("");
    setConcernedDepartments([]);
    setRemarks("");
    setAdditionalNames([""]);
    setPrintName("");
  };

  // Function to update the Print Name dynamically
  useEffect(() => {
    const baseParts = [itemName, size, color].filter(Boolean);
    const baseName = baseParts.join(" ");

    const additionalDetails = [make, grade].filter(Boolean).join(" ");
    const fullAdditional = [additionalDetails, brandName].filter(Boolean).join(" - ");

    const newPrintName = fullAdditional
      ? `${baseName} - ${fullAdditional}`
      : baseName;

    setPrintName(newPrintName.toUpperCase());
  }, [itemName, color, size, make, grade, brandName]);

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };
  const handleItemsChange = (selectedOptions) => {
    setSelectedItems(selectedOptions || []);
  };

  const handleSelectChange = (selectedOption, { name }) => {
    if (name === "itemGroup") {
      setItemGroup(selectedOption)
      setItemGroupCode(selectedOption?.itemGroupCode || "")
    }
    if (name === "uom") {
      setUom(selectedOption)
      setUnit(selectedOption?.unit || "")
    }
    if (name === "type") {
      setType(selectedOption)
      if (selectedOption.value == "Constructed Structure") {
        setSize("");
        setColor("");
        setGrade("");
        setMake("");
        setBrandName("");
        setAvgWeight("");
        setDisableStructureFields(true);
      } else {
        setDisableStructureFields(false);
      }
    }
  };

  const handleConcernedDeptSelectChange = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "all")) {
      setConcernedDepartments(departments);
    } else {
      setConcernedDepartments(selectedOptions);
    }
  };
  const getOptions = () => {
    return [{ value: "all", label: "Select All" }, ...departments];
  };

  const handleAdditionalNameChange = (index, value) => {
    const newAdditionalNames = [...additionalNames];
    newAdditionalNames[index] = value;
    setAdditionalNames(newAdditionalNames);
  };

  const handleAddAdditionalName = () => {
    setAdditionalNames([...additionalNames, ""]);
  };

  const handleDeleteAdditionalName = (index) => {
    const newAdditionalNames = [...additionalNames];
    newAdditionalNames.splice(index, 1);
    setAdditionalNames(newAdditionalNames);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all required fields are filled
    if (!itemName) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Enter Inventory Name!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }
    if (!itemGroup) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select Inventory Group!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }
    if (!type) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select Inventory type!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }
    if (!concernedDepartments.length) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select at least One Department!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }
    if (!uom) {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Pleaser Select UOM!',
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
        toast: true,
      });
      return;
    }

    let submissionData = {
      itemName,
      itemGroup: itemGroup?.value || null,
      itemGroupCode,
      type: type?.value || null,
      itemDesc,
      size,
      make,
      color,
      avgWeight,
      grade,
      brandName,
      printName,
      uom: uom?.value || null,
      unit,
      concernedDepartments: concernedDepartments?.map((d) => d.value) || [],
      additionalNames: additionalNames || [],
      code,
      email,
      remarks,
      onlyDept:onlyDept?true:false
    };

    try {
      // Attempt to save the item
      if (isEdit) {
        submissionData = { ...submissionData, itemCode: itemCode }

        // Update API call
        await apiClient.post(`${SERVER_BASE}/editItem/${editItemId}`, submissionData, {
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          }
        });
        Swal.fire({
          icon: 'success',
          title: 'Inventory updated successfully!',
          toast: true,
          position: 'top-end',
          timer: 2000,
          showConfirmButton: false,
        });
        setEditItemId(null);
        setIsEdit(false);
      } else {
        // Create API call
        const response = await apiClient.post(SERVER_BASE + "/save-item", submissionData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        Swal.fire({
          icon: 'success',
          title: 'Created!',
          toast: true,
          position: 'top-end',  // Positioning Swal to the right end
          showConfirmButton: false,
          timer: 1500, // Auto close after 1.5 seconds
        });
      }
      navigate('../InventoryMasterListing')
    } catch (error) {
      console.error("Error saving data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data.message,
        position: 'top-end',  // Positioning Swal to the right end
        showConfirmButton: false,
        timer: 1500, // Auto close after 1.5 seconds
      });
    }
  };

  const handleSubmitGroup = (e) => {
    e.preventDefault();

    if (groupItemName.trim() === '' || selectedItems.length === 0) {
      Swal.fire('Please fill both the required fields', '', 'warning');
      return;
    }

    // Retrieve token from localStorage
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('Unauthorized: No token found.');
      Swal.fire('Unauthorized', 'You need to log in to perform this action.', 'error');
      return;
    }

    const itemsNames = selectedItems.map((item) => item.value);

    Swal.fire({
      title: editIndex !== null ? 'Confirm Update' : 'Confirm Create',
      text: editIndex !== null ? 'Are you sure you want to update this group?' : 'Are you sure you want to create this group?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (editIndex !== null) {
            await apiClient.put(
              `${SERVER_BASE}/updateGroupItem/${editIndex}`,
              {
                name: groupItemName,
                itemNames: itemsNames,
                code,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
              }
            );
            // fetchPurposes();
            setEditIndex(null);
          } else {
            // Create new purpose
            await apiClient.post(
              `${SERVER_BASE}/addGroupItem`,
              {
                name: groupItemName,
                itemNames: itemsNames,
                code,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
              }
            );
            // fetchPurposes();
          }

          resetGroupForm();
          Swal.fire(
            editIndex !== null ? 'Updated!' : 'Created!',
            `Group has been ${editIndex !== null ? 'updated' : 'created'}.`,
            'success'
          );
          fetchGroupItems();
        } catch (error) {
          console.error('Error saving group:', error);
          Swal.fire('Error', error.response.data.message, 'error');
        }
      }
    });
  };

  const handleEdit = (item) => {
    setFormVisible(true);
    setShowForm(false)
    resetGroupForm();
    setIsEdit(true);
    setEditItemId(item.id);
    setItemName(item.itemName)
    setAvgWeight(item.avgWeight)
    setColor(item.color)
    setSize(item.size)
    setMake(item.make)
    setGrade(item.grade)
    setBrandName(item.brandName)
    setPrintName(item.printName)
    setRemarks(item.remarks)
    setItemDesc(item.itemDesc)
    setItemCode(item.itemCode)
    // Ensure department and prefix are arrays
    const departmentArray = Array.isArray(item.concernedDepartments)
      ? item.concernedDepartments
      : item.concernedDepartments
        ? item.concernedDepartments?.split(',') // If comma-separated string
        : [];

    setConcernedDepartments(departmentArray.map((d) => ({ value: d, label: d })));
    setItemGroup({ label: `${item.itemGroupCode} - ${item.itemGroup}`, value: item.itemGroup })
    setType({ label: item.type, value: item.type })
    setUom({ label: `${item.unit} - ${item.uom}`, value: item.uom });
    setItemGroupCode(item.itemGroupCode);
    setUnit(item.unit);
    const additionalNamesArray = Array.isArray(item.additionalNames)
      ? item.additionalNames
      : item.additionalNames
        ? item.additionalNames?.split(',') // If comma-separated string
        : [""];
    setAdditionalNames(additionalNamesArray.map((name) => name));
  };

  const handleEditGroup = (row) => {
    setGroupItemName(row?.groupItemName);
    const associatedItems = row?.itemGroups.map((item) => {
      return { value: item.printItemName, label: item.printItemName };
    });
    setSelectedItems(associatedItems);
    setEditIndex(row.groupId);
    setShowForm(true);
    setFormVisible(false);
    resetForm();
  };

  const handleClone = (item) => {
    setFormVisible(true);
    setShowForm(false)
    resetGroupForm();
    setItemName(item.itemName)
    setAvgWeight(item.avgWeight)
    setColor(item.color)
    setSize(item.size)
    setMake(item.make)
    setGrade(item.grade)
    setBrandName(item.brandName)
    setPrintName(item.printName)
    setRemarks(item.remarks)
    setItemDesc(item.itemDesc)
    setItemCode(item.itemCode)
    // Ensure department and prefix are arrays
    const departmentArray = Array.isArray(item.concernedDepartments)
      ? item.concernedDepartments
      : item.concernedDepartments
        ? item.concernedDepartments?.split(',') // If comma-separated string
        : [];

    setConcernedDepartments(departmentArray.map((d) => ({ value: d, label: d })));
    setItemGroup({ label: `${item.itemGroupCode} - ${item.itemGroup}`, value: item.itemGroup })
    setType({ label: item.type, value: item.type })
    setUom({ label: `${item.unit} - ${item.uom}`, value: item.uom });
    setItemGroupCode(item.itemGroupCode);
    setUnit(item.unit);
    const additionalNamesArray = Array.isArray(item.additionalNames)
      ? item.additionalNames
      : item.additionalNames
        ? item.additionalNames?.split(',') // If comma-separated string
        : [""];
    setAdditionalNames(additionalNamesArray.map((name) => name));
  };

  const handleDelete = async (row) => {
    const { id } = row;  // Destructure the necessary fields from row.original
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this Inventory? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.delete(SERVER_BASE + '/deleteItemMaster', {
          data: { id: id, code },
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });

        fetchItems();

        Swal.fire({
          icon: 'success',
          title: 'Inventory deleted successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error deleting Inventory:', error);

        Swal.fire({
          icon: 'error',
          title: 'An error occurred while deleting the Inventory.',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  };

  const handleDeleteGroup = (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this purpose!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await apiClient.delete(`${SERVER_BASE}/deleteGroupItem/${index}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
            data: { code },
            // Include 'code' in the delete request
          });
          fetchGroupItems();
          Swal.fire('Deleted!', 'Your group has been deleted.', 'success');
        } catch (error) {
          console.error('Error deleting group:', error);
          Swal.fire('Error', 'There was an issue deleting the group. Please try again later.', 'error');
        }
      }
    });
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await Promise.all([fetchItemGroups(), fetchDepartments(),fetchItems(),fetchUOMs(),fetchGroupItems()]);
      } catch (err) {
        console.error("Initial data fetch failed", err);
      } finally {
        setLoadingData(false); // ✅ Hide spinner when both are done
      }
    };
    fetchInitialData();
  }, []);
  


  // React Table configuration
  const columns = React.useMemo(
    () => [
      { Header: "Group", accessor: "itemGroupCode" },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ value }) => {
          // Conditional rendering based on the value of "type"
          if (value === "Asset") {
            return "AC";
          } else if (value === "Consumables") {
            return "CU";
          } else if (value === "Fixtures & Fittings") {
            return "FF";
          } else {
            return value; // Return the original value if no match is found
          }
        }
      },
      { Header: "Inventory", accessor: "printName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Additional Names", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      { Header: "Status", accessor: "status" },
      { Header: "Reason", accessor: "rejectedReason" },
      {
        Header: "Created By",
        accessor: "createdByFirstName",
        Cell: ({ row }) => {
          const { createdByFirstName, createdAt } = row.original; // Access original row data
          const formattedDate = new Date(createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
          }); // Format date as DD-MM
          return `${createdByFirstName} On (${formattedDate})`;
        },
      },
      {
        Header: "Actions",
        Cell: ({ row }) => {

          const item = row.original;

          return (
            <>
              {(role === 'itManager' ) && (
                <div className="dropdown">
                  <button
                    className="btn btn-light btn-sm"
                    type="button"
                    id={`dropdownMenuButton${row.index}`}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton${row.index}`}>

                    {(role === 'itManager') && item.status !== 'Final' && (
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleEdit(item)}
                        >
                          <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
                        </button>
                      </li>
                    )}

                    {(role === 'itManager') && item.status !== 'Final' && (
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleDelete(item)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="me-2" /> Delete
                        </button>
                      </li>
                    )}

                    {(role === 'itManager') && (
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleClone(item)}
                        >
                          <FontAwesomeIcon icon={faCopy} className="me-2" /> Clone
                        </button>
                      </li>
                    )}

                  </ul>
                </div>
              )}
            </>
          );
        },
      }
    ],
    []
  );

  const columnsGroups = React.useMemo(
    () => [
      { Header: "Group Name", accessor: "groupItemName" },
      {
        Header: "Items",
        accessor: "itemGroups",
        Cell: ({ cell: { value } }) => (
          <span>{value.map((item) => item.printItemName).join(", ")}</span>
        ),
      },
      {
        Header: 'Action',
        Cell: ({ row }) => {
          return (
            <>
              {(role == 'itManager') && (
                <button className="btn btn-sm btn-success me-2" onClick={() => handleEditGroup(row.original)}>
                  <FontAwesomeIcon icon={faEdit} />
                </button>
              )}
              {(role == 'itManager' ) && (
                <button className="btn btn-sm btn-danger" onClick={() => handleDeleteGroup(row.original.groupId)}>
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              )}
            </>
          )
        },
      },
    ],
    []
  );

  const exportToExcel = () => {
    const formattedData = items.map(itm => ({
      "Item Name": itm.printName,
      "UOM": itm.uom,
      "Weight": itm.avgWeight,
      "Additional Names": itm.additionalNames,
      "Departments": itm.concernedDepartments
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Item List");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Item_list.xlsx");
  };
  const tableInstance1 = useTable(
    { columns, data: items, initialState: { pageIndex: 0, pageSize: 25 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const tableInstance2 = useTable(
    { columns: columnsGroups, data: groupItems, initialState: { pageIndex: 0, pageSize: 25 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  // Helper for Rendering Tables
  const renderTable = ({
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex = 0, pageSize = 25, globalFilter },
    setGlobalFilter,
    pageOptions = [],
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    setPageSize,
    state
  }) => {
    // Get the filtered rows count
    const filteredRowsCount = page.length;

    return (
      <div>
        <div className="row align-items-center">
          {/* Global Filter (Search Bar) */}
          <div className="col-md-9">
            <GlobalFilter filter={state.globalFilter} setFilter={setGlobalFilter} />
          </div>

          {/* Display the number of search results in an input field */}
          <div className="col-md-1">
            <input
              type="text"
              value={`${filteredRowsCount} Count Per Page`}
              style={{
                marginBottom: '10px',
                padding: '8px',
                fontSize: '16px',
                width: '100%',
                boxSizing: 'border-box',
              }}
              disabled
              className="form-control w-auto"
            />

          </div>
        </div>


        <table {...getTableProps()} className="table table-striped" style={{ fontSize: "13px", verticalAlign: "baseline" }}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            <button
              className="btn btn-secondary me-2"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              Previous
            </button>
            <button
              className="btn btn-secondary"
              onClick={nextPage}
              disabled={!canNextPage}
            >
              Next
            </button>
          </div>
          <span>
            Page {pageIndex + 1} of {pageOptions.length}
          </span>
          <select
            className="form-select w-auto"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[25, 50, 75, 100].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };
  if (loadingData ) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fs-5">Please Wait...</div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Inventory Master</h3>
        <div className="ledger-count">
          Total Items: <strong>{items.length}</strong>
        </div>
      </div>
        <>
          <button onClick={toggleFormVisibility} className="btn btn-success mb-3">
            {formVisible ? 'Cancel' : 'Add Inventory'}
          </button>
          {/* <button className="btn btn-success mb-3 ms-2" onClick={toggleGroupFormVisibility}>
        {showForm ? 'Cancel' : 'Group Inventory'}
      </button> */}
          {formVisible && (<>
            <h4 className="text-center">{printName}</h4>
            <div className="formcontainer">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <label>Inventory Group</label>
                    <Select
                      options={itemGroups}
                      name="itemGroup"
                      onChange={handleSelectChange}
                      value={itemGroup}
                      isDisabled={onlyDept}
                    />
                  </div>
                  {/* <div className="col-md-3">
            <label>Inventory Group Code</label>
            <input
              type="text"
              className="form-control"
              name="itemGroupCode"
              value={itemGroupCode}
              disabled
            />
          </div> */}
                  <div className="col-md-3">
                    <label>Type</label>
                    <Select
                      options={[
                        { value: "Asset", label: "Asset / Capital Nature" },
                        { value: "Consumables", label: "Useable / Consumables" },
                        { value: "Fixtures & Fittings", label: "Fixtures & Fittings" },
                        { value: "Constructed Structure", label: "Constructed Structure" },
                        { value: "On Rent / Hire", label: "On Rent / Hire" },
                      ]}
                      name="type"
                      onChange={handleSelectChange}
                      value={type}
                      isDisabled={onlyDept}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Print Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="printName"
                      value={printName}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Inventory Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="itemName"
                      value={itemName}
                      disabled={onlyDept}
                      onChange={handleChange(setItemName)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Size</label>
                    <input
                      type="text"
                      className="form-control"
                      name="size"
                      disabled={onlyDept || disableStructureFields}
                      value={size}
                      onChange={handleChange(setSize)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Color</label>
                    <input
                      type="text"
                      className="form-control"
                      name="color"
                      value={color}
                      disabled={onlyDept || disableStructureFields}
                      onChange={handleChange(setColor)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Made of (Material)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="make"
                      value={make}
                      disabled={onlyDept || disableStructureFields}
                      onChange={handleChange(setMake)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Grade</label>
                    <input
                      type="text"
                      className="form-control"
                      name="grade"
                      value={grade}
                      disabled={onlyDept || disableStructureFields}
                      onChange={handleChange(setGrade)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Brand Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="brandName"
                      value={brandName}
                      disabled={onlyDept || disableStructureFields}
                      onChange={(e) => setBrandName(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Avg Weight</label>
                    <input
                      type="text"
                      className="form-control"
                      name="avgWeight"
                      value={avgWeight}
                      disabled={onlyDept || disableStructureFields}
                      onChange={(e) => setAvgWeight(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>UOM</label>
                    <Select
                      options={uoms}
                      name="uom"
                      onChange={handleSelectChange}
                      value={uom}
                      isDisabled={onlyDept}
                    />
                  </div>
                  <div className="col-md-6">
                    <label>Store Issuer Deptt</label>
                    <Select
                      isMulti
                      options={getOptions()}
                      name="concernedDepartments"
                      onChange={handleConcernedDeptSelectChange}
                      value={concernedDepartments}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Inventory Description</label>
                    <input
                      type="text"
                      className="form-control"
                      name="itemDesc"
                      disabled={onlyDept}
                      value={itemDesc}
                      onChange={(e) => setItemDesc(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Remarks</label>
                    <input
                      type="text"
                      className="form-control"
                      name="remarks"
                      value={remarks}
                      disabled={onlyDept}
                      onChange={(e) => setRemarks(e.target.value)}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label>Additional Names</label>
                  <div className="d-flex flex-wrap">
                    {additionalNames.map((name, index) => (
                      <div
                        key={index}
                        className="me-3 mb-2 d-flex align-items-center"
                        style={{ flexShrink: 0 }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "210px" }}
                          placeholder={`Name ${index + 1}`}
                          value={name}
                          onChange={(e) =>
                            handleAdditionalNameChange(index, e.target.value)
                          }
                        />
                        {additionalNames.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-danger ms-2"
                            onClick={() => handleDeleteAdditionalName(index)}
                            disabled={onlyDept}
                          >
                            <FontAwesomeIcon icon={faMinusCircle} />
                          </button>
                        )}
                        {index === additionalNames.length - 1 && (
                          <button
                            type="button"
                            className="btn btn-success   ms-2"
                            onClick={handleAddAdditionalName}
                            disabled={onlyDept}
                          >
                            <FontAwesomeIcon icon={faPlusCircle} />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                {/* <div class="border-top border-success p-1 mt-2"></div>
          <div className="row mb-3">
            <div className="col-md-3">
              <label>MMS Code</label>
              <input
                type="text"
                className="form-control"
                name="mmsCode"
                value={formData.mmsCode}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-3">
              <label>MMS Inventory Name</label>
              <input
                type="text"
                className="form-control"
                name="mmsName"
                value={formData.mmsName}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-3">
              <label>MMS Description</label>
              <input
                type="text"
                className="form-control"
                name="mmsDesc"
                value={formData.mmsDesc}
                onChange={handleChange}
              />
            </div>
          </div> */}

                <button type="submit" className="btn btn-success">
                  Submit
                </button>
              </form>
            </div>
          </>)}
        </>
     
    </div>
  );
};

export default ItemMaster;
